import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import JsonLd from "../../components/base/JsonLd";
import Hero from "./components/Hero";
import PlatformBand from "./components/PlatformBand";
import FeedSection from "./components/FeedSection";
import RankSection from "./components/RankSection";
import FeatureSection from "./components/FeatureSection";
import FaqSection from "./components/FaqSection";
import { articles, faqs, platforms, siteMeta } from "../../mocks/gossip";
import useSeo from "../../hooks/useSeo";
import { Link } from "react-router-dom";

const BASE = "https://qihang77.cn";

export default function Home() {
  useSeo({
    title: "明星爆料-全网明星八卦聚合吃瓜站 微博热搜·豆瓣·知乎·天涯",
    description:
      "明星爆料聚合微博热搜、豆瓣小组、知乎深扒、公众号长文、天涯神帖与贴吧讨论六大平台的明星高能爆料，全网追踪娱乐八卦，为你整理完整事件脉络与最新进展，一站式吃透每一个瓜。",
    keywords: "明星爆料,明星八卦,微博热搜,豆瓣小组,知乎深扒,公众号长文,天涯神帖,贴吧讨论,娱乐圈吃瓜",
    path: "/",
    type: "website",
  });

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteMeta.name,
    url: BASE,
    slogan: siteMeta.slogan,
    description: siteMeta.desc,
  };
  const siteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteMeta.name,
    url: BASE,
    description: siteMeta.desc,
    inLanguage: "zh-CN",
  };
  const hotSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "全网热搜榜",
    itemListElement: articles.slice(0, 4).map((a, i) => ({
      "@type": "ListItem",
      position: i + 1,
      url: `${BASE}/article/${a.id}`,
      name: a.title,
    })),
  };
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <JsonLd data={[orgSchema, siteSchema, hotSchema, faqSchema]} />
      <Navbar />
      <main>
        <Hero />
        <PlatformBand />
        <FeedSection />
        <RankSection />
        <FeatureSection />
        <FaqSection />
        {/* 频道快捷入口（底部） */}
        <section className="bg-background-50">
          <div className="mx-auto max-w-7xl px-4 md:px-8 py-8 flex flex-wrap items-center justify-center gap-2.5">
            <span className="text-xs text-foreground-400 mr-1 whitespace-nowrap">快速直达：</span>
            {platforms.map((p) => (
              <Link
                key={p.slug}
                to={`/channel/${p.slug}`}
                className="rounded-full bg-background-100 px-4 py-1.5 text-xs text-foreground-600 hover:text-primary-700 hover:bg-primary-50 transition whitespace-nowrap"
              >
                {p.short}
              </Link>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}